export default __webpack_public_path__ + "static/media/how_to_play_bg.8bbea0dc.svg";